// actions.js
import axios from 'axios';
import {
  LOGIN_GYM_REQUEST,
  LOGIN_GYM_SUCCESS,
  LOGIN_GYM_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  GET_USERS_FAILURE,
  CREATE_TRAINER_REQUEST,
  CREATE_TRAINER_SUCCESS,
  CREATE_TRAINER_FAILURE,
  GET_TRAINERS_REQUEST,
  GET_TRAINERS_SUCCESS,
  GET_TRAINERS_FAILURE,
  REGISTER_ENTRY_REQUEST,
  REGISTER_ENTRY_SUCCESS,
  REGISTER_ENTRY_FAILURE,
  REGISTER_TRAINER_ENTRY_REQUEST,
  REGISTER_TRAINER_ENTRY_SUCCESS,
  REGISTER_TRAINER_ENTRY_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  CREATE_PAYMENT_REQUEST,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_FAILURE,
  GET_USER_PAYMENTS_REQUEST,
  GET_USER_PAYMENTS_SUCCESS,
  GET_USER_PAYMENTS_FAILURE,
  GET_MONTHLY_BALANCE_REQUEST,
  GET_MONTHLY_BALANCE_SUCCESS,
  GET_MONTHLY_BALANCE_FAILURE,
  GET_GYM_BALANCE_REQUEST,
  GET_GYM_BALANCE_SUCCESS,
  GET_GYM_BALANCE_FAILURE,  
} from './actionTypes';

// Acción asíncrona para login de gimnasio
export const loginGym = (email, password) => async (dispatch) => {
  dispatch({ type: LOGIN_GYM_REQUEST });
  try {
    const response = await axios.post('/auth/login-gym', {
      email,
      password
    });
    dispatch({
      type: LOGIN_GYM_SUCCESS,
      payload: response.data // aquí puedes guardar el token o datos del gym
    });
    console.log(response.data);
  } catch (error) {
    dispatch({
      type: LOGIN_GYM_FAILURE,
      payload: error.response?.data?.message || 'Error al iniciar sesión'
    });
  }
};

// Acción asíncrona para crear usuario (socio)
export const createUser = (userData) => async (dispatch) => {
  dispatch({ type: CREATE_USER_REQUEST });
  try {
    const response = await axios.post('/users', userData);
    dispatch({
      type: CREATE_USER_SUCCESS,
      payload: response.data // aquí puedes guardar el usuario creado o mensaje
    });
  } catch (error) {
    dispatch({
      type: CREATE_USER_FAILURE,
      payload: error.response?.data?.message || 'Error al crear usuario'
    });
  }
};

// Acción para traer usuarios de un gimnasio
export const getUsers = (gymId, search = '') => async (dispatch) => {
  dispatch({ type: GET_USERS_REQUEST });
  try {
    const response = await axios.get('/users', {
      params: { gymId, search }
    });
    dispatch({
      type: GET_USERS_SUCCESS,
      payload: {
        users: response.data.users,
        total: response.data.total
      }
    });
  } catch (error) {
    dispatch({
      type: GET_USERS_FAILURE,
      payload: error.response?.data?.message || 'Error al obtener usuarios'
    });
  }
};

export const createTrainer = (trainerData) => async (dispatch) => {
  dispatch({ type: CREATE_TRAINER_REQUEST });
  try {
    const response = await axios.post('/trainers', trainerData);
    dispatch({
      type: CREATE_TRAINER_SUCCESS,
      payload: response.data // trainer creado o mensaje
    });
  } catch (error) {
    dispatch({
      type: CREATE_TRAINER_FAILURE,
      payload: error.response?.data?.message || 'Error al crear entrenador'
    });
  }
};

export const getTrainers = (gymId, search = '') => async (dispatch) => {
  dispatch({ type: GET_TRAINERS_REQUEST });
  try {
    const response = await axios.get('/trainers', {
      params: { gymId, search }
    });
    dispatch({
      type: GET_TRAINERS_SUCCESS,
      payload: {
        trainers: response.data.trainers,
        total: response.data.total
      }
    });
  } catch (error) {
    dispatch({
      type: GET_TRAINERS_FAILURE,
      payload: error.response?.data?.message || 'Error al obtener entrenadores'
    });
  }
};

export const registerEntry = (dni, gymId) => async (dispatch) => {
  dispatch({ type: REGISTER_ENTRY_REQUEST });

  try {
    const response = await axios.post('/entries', { dni, gymId });

    dispatch({
      type: REGISTER_ENTRY_SUCCESS,
      payload: {
        message: response.data.message,
        user: response.data.user,       // <-- incluimos el user
        entry: response.data.entry      // <-- opcional si querés también los datos de entrada
      }
    });
  } catch (error) {
    dispatch({
      type: REGISTER_ENTRY_FAILURE,
      payload: error.response?.data?.message || 'Error al registrar ingreso'
    });
  }
};
// Acción asíncrona para registrar ingreso de entrenador
export const registerTrainerEntry = (dni, gymId) => async (dispatch) => {
  dispatch({ type: REGISTER_TRAINER_ENTRY_REQUEST });
  try {
    const response = await axios.post('/trainer-entries', { dni, gymId });
    dispatch({
      type: REGISTER_TRAINER_ENTRY_SUCCESS,
      payload: response.data.message
    });
  } catch (error) {
    dispatch({
      type: REGISTER_TRAINER_ENTRY_FAILURE,
      payload: error.response?.data?.message || 'Error al registrar ingreso de entrenador'
    });
  }
};

export const updateUser = (id, updatedData) => async (dispatch) => {
  dispatch({ type: UPDATE_USER_REQUEST });
  try {
    const response = await axios.put(`/users/${id}`, updatedData);
    dispatch({
      type: UPDATE_USER_SUCCESS,
      payload: response.data.user  // Asumimos que devolvés el usuario actualizado
    });
  } catch (error) {
    dispatch({
      type: UPDATE_USER_FAILURE,
      payload: error.response?.data?.message || 'Error al actualizar usuario'
    });
  }
};


export const getUserById = (id) => async (dispatch) => {
  dispatch({ type: GET_USER_REQUEST });
  try {
    const { data } = await axios.get(`/users?id=${id}`);
    dispatch({ type: GET_USER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ 
      type: GET_USER_FAIL, 
      payload: error.response && error.response.data.message 
        ? error.response.data.message 
        : error.message 
    });
  }
};


// Crear nuevo pago
export const createPayment = (paymentData) => async (dispatch) => {
  dispatch({ type: CREATE_PAYMENT_REQUEST });
  try {
    const response = await axios.post('/payments', paymentData);
    dispatch({ type: CREATE_PAYMENT_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: CREATE_PAYMENT_FAILURE,
      payload: error.response?.data?.message || 'Error al registrar el pago',
    });
  }
};

// Obtener pagos por userId
export const getUserPayments = (userId) => async (dispatch) => {
  dispatch({ type: GET_USER_PAYMENTS_REQUEST });
  try {
    const response = await axios.get(`/payments/user/${userId}`);
    dispatch({ type: GET_USER_PAYMENTS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: GET_USER_PAYMENTS_FAILURE,
      payload: error.response?.data?.message || 'Error al obtener pagos del usuario',
    });
  }
};

// Obtener balance mensual
export const getMonthlyBalance = () => async (dispatch) => {
  dispatch({ type: GET_MONTHLY_BALANCE_REQUEST });
  try {
    const response = await axios.get('/payments/balance');
    dispatch({ type: GET_MONTHLY_BALANCE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: GET_MONTHLY_BALANCE_FAILURE,
      payload: error.response?.data?.message || 'Error al obtener el balance mensual',
    });
  }
};

// Obtener balance por gimnasio
export const getGymBalance = (gymId) => async (dispatch) => {
  dispatch({ type: GET_GYM_BALANCE_REQUEST });
  try {
    const response = await axios.get(`/payments/gym/${gymId}`);
    dispatch({ type: GET_GYM_BALANCE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: GET_GYM_BALANCE_FAILURE,
      payload: error.response?.data?.message || 'Error al obtener el balance del gimnasio',
    });
  }
};